var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElderly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.64062 3.04688C1.93949 3.04688 1.37109 2.47848 1.37109 1.77734V1.26953C1.37109 0.568395 1.93949 0 2.64062 0C3.34176 0 3.91016 0.568395 3.91016 1.26953V1.77734C3.91016 2.47848 3.34176 3.04688 2.64062 3.04688Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36328 11.7305C6.94258 11.7305 6.60156 12.0715 6.60156 12.4922V12.6191C6.60156 12.8295 6.77209 13 6.98242 13H7.74414C7.95448 13 8.125 12.8295 8.125 12.6191V12.4922C8.125 12.0715 7.78398 11.7305 7.36328 11.7305Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.70166 8.75977L0.914865 12.64C0.925935 12.8419 1.09293 13 1.29514 13H3.04709C3.2493 13 3.4163 12.8419 3.42739 12.64L3.64057 8.75977H0.70166Z",
    fill: "#757575"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74434 11.017V6.72851C7.74434 6.23271 7.48442 5.79675 7.09389 5.54889C7.05534 5.81813 6.94606 6.0647 6.78564 6.26953C6.90686 6.38518 6.98262 6.54811 6.98262 6.72851V11.017C7.1044 10.9855 7.23201 10.9687 7.36348 10.9687C7.49496 10.9687 7.62257 10.9855 7.74434 11.017Z",
    fill: "#757575"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.58594 4.57032H4.31641V4.21486C4.31641 3.8664 4.19087 3.54739 3.9828 3.30011C3.62461 3.61622 3.15479 3.80861 2.64062 3.80861C2.01594 3.80861 1.45641 3.52494 1.08352 3.0799C0.436185 3.45248 0 4.15067 0 4.95118V7.6172C0 7.82754 0.170523 7.99806 0.380859 7.99806H3.93555C4.14588 7.99806 4.31641 7.82754 4.31641 7.6172V6.85548H3.42773C3.30787 6.85548 3.19498 6.79904 3.12305 6.70314L2.36133 5.68751C2.23511 5.51925 2.26924 5.28053 2.4375 5.15431C2.60579 5.02809 2.84451 5.06224 2.9707 5.23048L3.61816 6.09376H5.58594C6.00663 6.09376 6.34766 5.75274 6.34766 5.33204C6.34766 4.91135 6.00663 4.57032 5.58594 4.57032Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElderly);
export default __webpack_public_path__ + "static/media/Elderly.1e8ffdc94e2a779211ec71a9911954a5.svg";
export { ForwardRef as ReactComponent };